// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b6d28591"};